// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="header-left">
        <Link to="/">
          <img src="/images/logo2.png" alt="Sharanga Logo" className="logo" />
        </Link>
      </div>

      <div className={`nav-toggle ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>☰</div>

      <nav className={`nav-links ${isMenuOpen ? 'mobile-visible' : ''}`}>
        <Link to="/" onClick={toggleMenu}>Home</Link>
        <Link to="/about" onClick={toggleMenu}>About Us</Link>
        <Link to="/operations" onClick={toggleMenu}>Operations</Link>
        <Link to="/products" onClick={toggleMenu}>Products</Link>
        <Link to="/market" onClick={toggleMenu}>Market</Link>
        <Link to="/contact" onClick={toggleMenu}>Contact Us</Link>
      </nav>
    </header>
  );
}

export default Header;
